import { useRouter } from "@tanstack/react-router";
import { useSyncExternalStore } from "react";
import { clearTransientChatRequests } from "./chat-controller";

export function ChatNavigationStateSync() {
    const router = useRouter();
    useSyncExternalStore(
        () =>
            router.subscribe("onResolved", (event) => {
                if (event.pathChanged) clearTransientChatRequests();
            }),
        () => null,
        () => null,
    );
    return null;
}
